module.exports = __webpack_public_path__ + "static/media/6.beb84815.jpg";